import { render, staticRenderFns } from "./ProductMainListIframe.vue?vue&type=template&id=efe9fa1a&"
import script from "./ProductMainListIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductMainListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports